
import Vue from 'vue';
import Component from 'vue-class-component';
import BaseLookup from './BaseLookup';
import TLookupSkin from './LookupSkin.vue';

@Component({
  name: 'FlowTriggerLookup',
  components: {
    TLookupSkin,
  },
})
export default class FlowTriggerLookup extends BaseLookup {
  dialogVisible = false;

  suggestionControllerName() {
    return 'FlowTrigger';
  }

  keyPrefix() {
    return 'FlowTrigger';
  }

  openDialog() {
    this.dialogVisible = true;
  }

  handleSelect(val) {
    this.addItem({
      key: val.key,
      title: val.value,
    });
  }
}
